export enum StatusSupplierInventoryImportEnum {
  Error = 1,
  Success = 2,
  Partial = 3,
  Scheduled = 4,
  Cancelled =5
}
